const autoNgTemplateLoaderTemplate1 = require('./customTemplatesList.html');

import angular from 'angular';

angular.module('portainer.app').component('customTemplatesList', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller: 'CustomTemplatesListController',
  bindings: {
    titleText: '@',
    titleIcon: '@',
    templates: '<',
    tableKey: '@',
    onSelectClick: '<',
    showSwarmStacks: '<',
    onDeleteClick: '<',
    isEditAllowed: '<',
    hideDeploymentOption: '<',
    createPath: '@',
    editPath: '@',
  },
});
